// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"1c3cad87","828":"d46dbbb8","963":"511997ad","967":"89e4e303"}[chunkId] + ".chunk.js";
};